/**
 * Salon C Academy – aanmeldformulier vooraf invullen
 *
 * Links in de academy-secties linken naar het formulier (#aanmelden).
 * Met deze data-attributen vult een klik het formulier alvast in:
 *
 *   data-academy-training="Kleurtechnieken"
 *     kiest de opleiding met die naam in de keuzelijst
 *     ([data-academy-training-select]); de naam moet in de lijst staan.
 *
 *   data-academy-intent="signup" | "info"
 *     vinkt het bijbehorende rondje aan
 *     ([data-academy-intent-option="signup"] / ["info"]).
 *
 * Zonder JavaScript springt de link gewoon naar het formulier.
 *
 * Nieuwsbrief: staat het vinkje [data-academy-newsletter-optin] aan, dan
 * onthoudt dit script naam, e-mailadres en de overige antwoorden
 * (sessionStorage) tot de pagina na het versturen terugkomt. Is de aanvraag gelukt ([data-academy-form-success]),
 * dan vult het daarmee het verborgen klantformulier
 * ([data-academy-newsletter-form]) en verstuurt dat in een verborgen iframe,
 * zodat de bevestiging in beeld blijft. De antwoorden (telefoon, opleiding,
 * aanvraag, opmerkingen) komen in de notitie van de klant.
 *
 * hCaptcha: Shopify koppelt de captcha pas aan een formulier bij focusin of
 * change, en houdt het versturen van een niet-gekoppeld formulier tegen. Het
 * verborgen formulier krijgt die events nooit, dus koppelen we het zelf met
 * Shopify.captcha.protect() en versturen het pas daarna.
 *
 * Na een geslaagde aanvraag haalt dit script ?contact_posted=true uit de URL,
 * zodat herladen het lege formulier toont in plaats van de bevestiging.
 */
(() => {
  if (window.hbcAcademyFormReady) return;
  window.hbcAcademyFormReady = true;

  const selectTraining = (name) => {
    const select = document.querySelector('[data-academy-training-select]');
    if (!select) return;

    const wanted = name.trim().toLowerCase();
    const option = Array.from(select.options).find((opt) => opt.value.trim().toLowerCase() === wanted);
    if (option) select.value = option.value;
  };

  const selectIntent = (intent) => {
    const radio = document.querySelector(`[data-academy-intent-option="${intent}"]`);
    if (radio) radio.checked = true;
  };

  const NEWSLETTER_KEY = 'hbcAcademyNewsletter';

  // Velden van het aanmeldformulier die in de klantnotitie komen, in deze volgorde.
  const NOTE_FIELDS = ['Telefoon', 'Opleiding', 'Aanvraag', 'Opmerkingen'];

  const buildNote = (form) => {
    const value = (name) => (form.elements[`contact[${name}]`]?.value ?? '').trim();
    const date = new Date().toLocaleDateString('nl-NL');
    const lines = NOTE_FIELDS.filter((name) => value(name)).map((name) => `${name}: ${value(name)}`);

    return [`${value('Onderwerp')} (${date})`, ...lines].join('\n');
  };

  const rememberNewsletter = (form) => {
    const optin = form.querySelector('[data-academy-newsletter-optin]');
    if (!optin) return;

    try {
      if (optin.checked) {
        const name = form.elements['contact[Naam]']?.value ?? '';
        const email = form.elements['contact[email]']?.value ?? '';
        const note = buildNote(form);
        sessionStorage.setItem(NEWSLETTER_KEY, JSON.stringify({ name, email, note }));
      } else {
        sessionStorage.removeItem(NEWSLETTER_KEY);
      }
    } catch {
      // Geen sessionStorage (bijv. privévenster): de aanvraag gaat gewoon door.
    }
  };

  const subscribeNewsletter = () => {
    const form = document.querySelector('[data-academy-newsletter-form]');
    if (!form || !document.querySelector('[data-academy-form-success]')) return;

    let data;
    try {
      data = JSON.parse(sessionStorage.getItem(NEWSLETTER_KEY));
      sessionStorage.removeItem(NEWSLETTER_KEY);
    } catch {
      return;
    }
    if (!data?.email) return;

    const [firstName = '', ...lastName] = data.name.trim().split(/\s+/);
    form.elements['contact[email]'].value = data.email;
    form.elements['contact[first_name]'].value = firstName;
    form.elements['contact[last_name]'].value = lastName.join(' ');
    form.elements['contact[note]'].value = data.note ?? '';

    const submit = () => form.requestSubmit();
    const captcha = window.Shopify?.captcha;
    if (captcha?.protect) {
      captcha.protect(form, submit);
    } else {
      submit();
    }
  };

  const forgetPostedState = () => {
    if (!document.querySelector('[data-academy-form-success]')) return;

    const url = new URL(window.location.href);
    if (!url.searchParams.has('contact_posted')) return;
    url.searchParams.delete('contact_posted');
    history.replaceState(history.state, '', url);
  };

  document.addEventListener('submit', (event) => {
    if (event.target instanceof HTMLFormElement) rememberNewsletter(event.target);
  });

  subscribeNewsletter();
  forgetPostedState();

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[data-academy-training], a[data-academy-intent]');
    if (!trigger) return;

    const { academyTraining, academyIntent } = trigger.dataset;
    if (academyTraining) selectTraining(academyTraining);
    if (academyIntent) selectIntent(academyIntent);
  });
})();
